import 'izitoast/dist/css/iziToast.min.css';
import iziToast from 'izitoast/dist/js/iziToast';

/*
id: null,
      class: '',
      title: '',
      titleColor: '',
      titleSize: '',
      titleLineHeight: '',
      message: '',
      messageColor: '',
      messageSize: '',
      messageLineHeight: '',
      backgroundColor: '',
      theme: 'light', // dark
      color: '', // blue, red, green, yellow
      icon: '',
      iconText: '',
      iconColor: '',
      image: '',
      imageWidth: 50,
      maxWidth: null,
      zindex: null,
      layout: 1,
      balloon: false,
      close: true,
      closeOnEscape: false,
      closeOnClick: false,
      rtl: false,
      position: 'bottomRight', // bottomRight, bottomLeft, topRight, topLeft, topCenter, bottomCenter, center
      target: '',
      targetFirst: true,
      toastOnce: false,
      timeout: 5000,
      animateInside: true,
      drag: true,
      pauseOnHover: true,
      resetOnHover: false,
      progressBar: true,
      progressBarColor: '',
      progressBarEasing: 'linear',
      overlay: false,
      overlayClose: false,
      overlayColor: 'rgba(0, 0, 0, 0.6)',
      transitionIn: 'fadeInUp',
      transitionOut: 'fadeOut',
      transitionInMobile: 'fadeInUp',
      transitionOutMobile: 'fadeOutDown',
      buttons: {},
      inputs: {},
      onOpening: function () {},
      onOpened: function () {},
      onClosing: function () {},
      onClosed: function () {}
 */

class Notification{
  id = null;
  customClass = '';
  title = '';
  titleColor = '';
  titleSize = '';
  titleLineHeight = '';
  message = '';
  layout = 1;
  balloon = false;
  close = true;
  zindex = 99999999;
  closeOnEscape = false;
  closeOnClick = false;
  position = 'bottomRight'; // bottomRight, bottomLeft, topRight, topLeft, topCenter, bottomCenter, center
  target = '';
  overlay = false;
  progressBar = false;
  timeout = false;
  drag = true;

  setPosition(position){
    this.position = position;
    return this;
  };

  getPosition(){
    return this.position;
  };

  setClass(customClass) {
    this.class = customClass;
    return this;
  };

  setTitleColor(titleColor){
    this.titleColor = titleColor;
    return this;
  };

  setTitleSize(titleSize){
    this.titleSize = titleSize;
    return this;
  };

  setTitleLineHeight(lineHeight){
    this.titleLineHeight = lineHeight;
    return this;
  };

  setMessageColor(color){
    this.messageColor = color;
    return this;
  };

  setMessageSize(size){
    this.messageSize = size;
    return this;
  };

  setMessageLineHeight(lineHeight){
    this.messageLineHeight = lineHeight;
    return this;
  };

  setBackgroundColor(backgroundColor){
    this.backgroundColor = backgroundColor;
    return this;
  };

  setCloseStatus(status){
    this.close = status;
    return this;
  };

  setCloseOnEscape(status){
    this.closeOnEscape = status;
    return this;
  };

  setCloseOnClick(status){
    this.closeOnClick = status;
    return this;
  };

  setBalloonStatus(status){
    this.balloon = status;
    return this;
  };

  setTimeout(timeout){
    this.timeout = timeout;
    return this;
  };

  onOpening(){
    return;
  };
  onOpened(){

  };
  onClosing(){

  };
  onClosed(){

  };

  getSettings() {
    return {
      id: this.id,
      'class': this.customClass,
      titleColor: this.titleColor,
      titleSize: this.titleSize,
      titleLineHeight: this.titleLineHeight,
      messageColor: this.messageColor,
      messageSize: this.messageSize,
      messageLineHeight: this.messageLineHeight,
      backgroundColor: this.backgroundColor,
      close: this.close,
      overlay: this.overlay,
      progressBar: this.progressBar,
      closeOnEscape: this.closeOnEscape,
      closeOnClick: this.closeOnClick,
      baloon: this.balloon,
      timeout: this.timeout,
      onOpening: function(){},
      onOpened: function(){},
      onClosing: function(){},
      onClosed: function(){},
      zindex: this.zindex,
      drag: this.drag,
      position: this.position

      /*theme: 'light', // dark
      color: '', // blue, red, green, yellow
      icon: '',
      iconText: '',
      iconColor: '',
      image: '',
      imageWidth: 50,
      maxWidth: null,
      zindex: null,
      layout: 1,
      rtl: false,
      target: '',
      targetFirst: true,
      toastOnce: false,
      timeout: 5000,
      animateInside: true,
      drag: true,
      pauseOnHover: true,
      resetOnHover: false,
      progressBar: true,
      progressBarColor: '',
      progressBarEasing: 'linear',
      overlay: false,
      overlayClose: false,
      overlayColor: 'rgba(0, 0, 0, 0.6)',
      transitionIn: 'fadeInUp',
      transitionOut: 'fadeOut',
      transitionInMobile: 'fadeInUp',
      transitionOutMobile: 'fadeOutDown',
      buttons: {},
      inputs: {},
      onOpening: function () {},
      onOpened: function () {},
      onClosing: function () {},
      onClosed: function () {}*/
    };
  }

  setSettings(){
    iziToast.settings(
      this.getSettings()
    );

    return this;
  }

  show(title, message){
    var settings = this.getSettings();

    if( typeof title == "object" ) {
      Object.assign(settings, settings, title)
    } else {
      settings.title   = title;
      settings.message = message;
    }

    iziToast.show(settings);
  };

  showInfo(title, message){

    var settings = this.getSettings();

    if( typeof title == "object" ) {
      Object.assign(settings, settings, title)
    } else {
      settings.title   = title;
      settings.message = message;
    }

    iziToast.info(settings);
  };

  showWarning(title, message){

    var settings = this.getSettings();

    if( typeof title == "object" ) {
      Object.assign(settings, settings, title)
    } else {
      settings.title   = title;
      settings.message = message;
    }

    iziToast.warning(settings);
  };

  showError(title, message){

    var settings = this.getSettings();

    if( typeof title == "object" ) {
      Object.assign(settings, settings, title)
    } else {
      settings.title   = title;
      settings.message = message;
    }

    iziToast.error(settings)
  };

  showModal(title, message, buttons){

    var settings = this.getSettings();

    if( typeof title == "object" ) {
      Object.assign(settings, settings, title)
    } else {    
      settings.title      = title;
      settings.message    = message;
      settings.zindex     = 999;
      settings.overlay    = true;
      settings.toastOnce  = true;
      settings.close      = false;
    }

    iziToast.question(settings);
  }
}

export const notification = new Notification();


// WEBPACK FOOTER //
// ./src/helpers/notification.js